import { defineMessages } from "react-intl";

const messages = defineMessages({
    slogen: {
        id: "memory.slogen",
    },
    description: {
        id: "memory.seo.description",
    },
});

export default messages;
